export default "__VITE_ASSET__69438202__"